export default __webpack_public_path__ + "static/media/plate-1.6f5cca38.jpg";